import AddIcon from "@mui/icons-material/Add";
import Box from "@mui/material/Box";
import Fab from "@mui/material/Fab";
import Paper from "@mui/material/Paper";
import { styled } from "@mui/material/styles";
import Grid from "@mui/material/Unstable_Grid2";
import { TreeView } from "@mui/x-tree-view/TreeView";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { v4 } from "uuid";
import {
  ACCOUNT_TYPES,
  edit as editAccount,
  deleteAccount,
  selectCanDeleteAccount,
} from "../../../redux/coa";
import AccountRow from "./AccountRow";
import AccountRowContextMenu from "./AccountRowContextMenu";

const ChartOfAccounts = (props) => {
  const dispatch = useDispatch();

  const [contextMenu, setContextMenu] = useState(null);
  const [contextMenuTargetAccount, setContextMenuTargetAccount] =
    useState(null);
  const [contextMenuTargetValue, setContextMenuTargetValue] = useState(null);

  const canDeleteContextMenuTargetAccount = useSelector((state) =>
    selectCanDeleteAccount(state, contextMenuTargetAccount?.id),
  );

  const closeContextMenu = () => {
    setContextMenu(null);
  };

  const showContextMenu = (targetAccount) => (event) => {
    setContextMenuTargetAccount(targetAccount);
    setContextMenuTargetValue(event.target?.innerText);
    setContextMenu(
      contextMenu === null
        ? { mouseX: event.clientX, mouseY: event.clientY }
        : null,
    );
  };

  const onContextMenu = (targetAccount) => (event) => {
    event.preventDefault();
    event.stopPropagation();
    showContextMenu(targetAccount)(event);
  };

  const [touchTimeoutId, setTouchTimeoutId] = useState(null);
  const TOUCH_DURATION = 1000;

  const onTouchStart = (targetAccount) => (event) => {
    setTouchTimeoutId(
      setTimeout(() => {
        showContextMenu(targetAccount)(event.touches[0]);
      }, TOUCH_DURATION),
    );
  };

  const onTouchEnd = () => {
    clearTimeout(touchTimeoutId);
  };

  const onTouchMove = () => {
    clearTimeout(touchTimeoutId);
  };

  const onAddNewClick = () => dispatch(editAccount({ id: v4() }));

  const onDeleteAccount = () => {
    if (contextMenuTargetAccount && canDeleteContextMenuTargetAccount) {
      dispatch(deleteAccount(contextMenuTargetAccount.id));
    }
  };

  const onEditAccount = () => {
    if (contextMenuTargetAccount) {
      dispatch(editAccount({ id: contextMenuTargetAccount.id }));
    }
  };

  return (
    <Box className={props.className}>
      <Paper elevation={1}>
        <Grid container xs={12} spacing={0} className="header">
          <Grid xs={12} sm={7} md={6}>
            Name
          </Grid>
          <Grid display={{ xs: "none", sm: "block" }} sm={5} md={3}>
            Type
          </Grid>
          <Grid display={{ xs: "none", md: "block" }} md={3}>
            Features
          </Grid>
        </Grid>
      </Paper>
      <AccountRowContextMenu
        contextMenu={contextMenu}
        onClose={closeContextMenu}
        targetValue={contextMenuTargetValue}
        canEdit={!!contextMenuTargetAccount}
        canDelete={canDeleteContextMenuTargetAccount}
        onDelete={onDeleteAccount}
        onEdit={onEditAccount}
      />
      <Grid style={{ height: "calc(100vh - 104px)" }}>
        <TreeView disableSelection className="AccountsTreeView">
          {Object.keys(ACCOUNT_TYPES).map((typeId) => (
            <AccountRow
              key={`coa-root-account-${ACCOUNT_TYPES[typeId]}`}
              id={typeId}
              root
              onContextMenu={onContextMenu}
              onTouchStart={onTouchStart}
              onTouchEnd={onTouchEnd}
              onTouchMove={onTouchMove}
            />
          ))}
        </TreeView>
      </Grid>
      <Fab className="AddNewButton" onClick={onAddNewClick}>
        <AddIcon />
      </Fab>
    </Box>
  );
};

export default styled(ChartOfAccounts)(
  ({ theme }) => `
  .header {
    font-family: notosans-regular;
    font-weight: 400;
    padding: 12px 40px 12px 16px;
    background-color: ${theme.palette.header.main};
  }

  .MuiGrid2-root {
    overflow-x: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .AddNewButton {
    position: absolute;
    bottom: 16px;
    right: 16px;
  }

  .AccountsTreeView {
  }
`,
);
